import type { MessageResponse } from '../types';

// Changes when a newer reply arrives, and when the short answer becomes the long one on the same row.
export function latestReplyKey(messages: MessageResponse[]): string | null {
  const latest = messages.find((m) => m.role === 'assistant' && m.status === 'completed');
  return latest ? `${latest.id}:${Boolean(latest.loading_more)}` : null;
}
